(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["good-to-know-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faq-section').forEach((section) => {
      initFAQ(section);
    });
  });

  function initFAQ(section) {
    const tabs = section.querySelectorAll('.faq-tab');
    const panels = section.querySelectorAll('.faq-panel');
    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    /* ==========================
     TAB SWITCHING
    ========================== */

    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        const category = this.dataset.category;

        // Reset tabs
        tabs.forEach((t) => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });

        // Hide all panels AND reset their items
        panels.forEach((p) => {
          p.classList.remove('active');
          p.style.height = ''; // reset inline height

          p.querySelectorAll('.faq-item').forEach((item) => {
            item.classList.remove('active');

            const answer = item.querySelector('.faq-answer');
            if (answer) answer.style.maxHeight = null;

            const btn = item.querySelector('.faq-question');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          });
        });

        // Activate selected tab
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');

        const activePanel = section.querySelector(`.faq-panel[data-category="${category}"]`);

        if (activePanel) {
          activePanel.classList.add('active');
        }
      });
    });

    /* ==========================
    MOBILE CATEGORY CLICK (SMOOTH)
    ========================== */

    const mobileCategories = section.querySelectorAll('.faq-mobile-category');

    mobileCategories.forEach((btn) => {
      btn.addEventListener('click', function () {
        const category = this.dataset.category;
        const targetPanel = section.querySelector(`.faq-panel[data-category="${category}"]`);
        if (!targetPanel) return;

        const isActive = targetPanel.classList.contains('active');

        // Collapse all panels
        panels.forEach((panel) => {
          if (panel.classList.contains('active')) {
            collapsePanel(panel);
          }
        });

        // If already open → just close it
        if (isActive) return;

        // Expand selected
        expandPanel(targetPanel);
      });
    });

    /* ==========================
     CLICK ON HEADING ONLY
    ========================== */

    section.addEventListener('click', function (e) {
      const heading = e.target.closest('.faq-heading');
      if (!heading) return;

      const item = heading.closest('.faq-item');
      if (!item) return;

      openItem(item, true);
    });

    /* ==========================
     KEYBOARD SUPPORT
    ========================== */

    section.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;

      const heading = e.target.closest('.faq-heading');
      if (!heading) return;

      e.preventDefault();

      const item = heading.closest('.faq-item');
      if (!item) return;

      openItem(item, true);
    });

    /* ==========================
     TOGGLE LOGIC
    ========================== */

    function openItem(item, updateUrl = false, shouldScroll = false) {
      const panel = item.closest('.faq-panel');
      if (!panel) return;

      const isOpen = item.classList.contains('active');

      // Close all items first
      panel.querySelectorAll('.faq-item').forEach((i) => {
        i.classList.remove('active');

        const answer = i.querySelector('.faq-answer');
        if (answer) answer.style.maxHeight = null;

        const btn = i.querySelector('.faq-question');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });

      // If already open → just close
      if (isOpen) {
        history.replaceState(null, null, window.location.pathname);
        return;
      }

      // Otherwise open it
      const answer = item.querySelector('.faq-answer');
      const button = item.querySelector('.faq-question');

      item.classList.add('active');

      if (answer) answer.style.maxHeight = answer.scrollHeight + 'px';
      if (button) button.setAttribute('aria-expanded', 'true');

      if (updateUrl) {
        history.replaceState(null, null, `#${item.id}`);
      }

      if (shouldScroll) {
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    /* ==========================
     DEEP LINK SUPPORT
     ========================== */

    function handleHash() {
      const hash = window.location.hash.replace('#', '');
      if (!hash) return false;

      const targetItem = section.querySelector(`#${hash}`);
      if (!targetItem) return false;

      const parentPanel = targetItem.closest('.faq-panel');
      if (!parentPanel) return false;

      const parentCategory = parentPanel.dataset.category;

      tabs.forEach((t) => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });

      panels.forEach((p) => p.classList.remove('active'));

      const correctTab = section.querySelector(`.faq-tab[data-category="${parentCategory}"]`);

      if (correctTab) {
        correctTab.classList.add('active');
        correctTab.setAttribute('aria-selected', 'true');
      }

      parentPanel.classList.add('active');

      setTimeout(() => {
        openItem(targetItem, false, true);
      }, 150);

      return true;
    }

    const hashHandled = handleHash();

    if (!hashHandled) {
      const firstPanel = section.querySelector('.faq-panel');
      const firstTab = section.querySelector('.faq-tab');

      // Reset everything
      panels.forEach((p) => {
        p.classList.remove('active');
      });

      tabs.forEach((t) => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });

      // DESKTOP → open first panel
      if (!isMobile) {
        if (firstPanel) firstPanel.classList.add('active');
        if (firstTab) {
          firstTab.classList.add('active');
          firstTab.setAttribute('aria-selected', 'true');
        }
      }

      // MOBILE → keep all collapsed
      if (isMobile) {
        panels.forEach((panel) => {
          const wrapper = panel.querySelector('.faq-items-wrapper');
          if (wrapper) {
            wrapper.style.height = '0px';
          }
        });
      }
    }

    window.addEventListener('hashchange', handleHash);

    function expandPanel(panel) {
      const wrapper = panel.querySelector('.faq-items-wrapper');
      if (!wrapper) return;

      panel.classList.add('active');

      const fullHeight = wrapper.scrollHeight;

      wrapper.style.height = '0px';

      requestAnimationFrame(() => {
        wrapper.style.height = fullHeight + 'px';
      });

      wrapper.addEventListener('transitionend', function handler() {
        wrapper.style.height = 'auto';
        wrapper.removeEventListener('transitionend', handler);
      });
    }

    function collapsePanel(panel) {
      const wrapper = panel.querySelector('.faq-items-wrapper');
      if (!wrapper) return;

      panel.querySelectorAll('.faq-item').forEach((item) => {
        item.classList.remove('active');

        const answer = item.querySelector('.faq-answer');
        if (answer) answer.style.maxHeight = null;

        const btn = item.querySelector('.faq-question');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });

      const fullHeight = wrapper.scrollHeight;

      wrapper.style.height = fullHeight + 'px';

      requestAnimationFrame(() => {
        wrapper.style.height = '0px';
      });

      wrapper.addEventListener('transitionend', function handler() {
        panel.classList.remove('active');
        wrapper.removeEventListener('transitionend', handler);
      });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.product-faq__question');
    if (!trigger) return;

    const item = trigger.closest('.product-faq__item');
    const section = trigger.closest('.product-faq');
    const panel = item.querySelector('.product-faq__answer');

    const isOpen = item.classList.contains('is-open');

    // Close all
    section.querySelectorAll('.product-faq__item').forEach((el) => {
      el.classList.remove('is-open');
      const content = el.querySelector('.product-faq__answer');
      content.style.height = 0;
    });

    // Open clicked if closed
    if (!isOpen) {
      item.classList.add('is-open');
      panel.style.height = panel.scrollHeight + 'px';
    }
  });

  // ✅ OPEN FIRST FAQ ON LOAD
  document.addEventListener('DOMContentLoaded', function () {
    const firstItem = document.querySelector('.product-faq__item');
    if (!firstItem) return;

    const firstAnswer = firstItem.querySelector('.product-faq__answer');

    firstItem.classList.add('is-open');
    firstAnswer.style.height = firstAnswer.scrollHeight + 'px';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sustainability-content-2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faq-section').forEach((section) => {
      initFAQ(section);
    });
  });

  function initFAQ(section) {
    const tabs = section.querySelectorAll('.faq-tab');
    const panels = section.querySelectorAll('.faq-panel');
    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    /* ==========================
     TAB SWITCHING
    ========================== */

    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        const category = this.dataset.category;

        // Reset tabs
        tabs.forEach((t) => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });

        // Hide all panels AND reset their items
        panels.forEach((p) => {
          p.classList.remove('active');
          p.style.height = ''; // reset inline height

          p.querySelectorAll('.faq-item').forEach((item) => {
            item.classList.remove('active');

            const answer = item.querySelector('.faq-answer');
            if (answer) answer.style.maxHeight = null;

            const btn = item.querySelector('.faq-question');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          });
        });

        // Activate selected tab
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');

        const activePanel = section.querySelector(`.faq-panel[data-category="${category}"]`);

        if (activePanel) {
          activePanel.classList.add('active');
        }
      });
    });

    /* ==========================
    MOBILE CATEGORY CLICK (SMOOTH)
    ========================== */

    const mobileCategories = section.querySelectorAll('.faq-mobile-category');

    mobileCategories.forEach((btn) => {
      btn.addEventListener('click', function () {
        const category = this.dataset.category;
        const targetPanel = section.querySelector(`.faq-panel[data-category="${category}"]`);
        if (!targetPanel) return;

        const isActive = targetPanel.classList.contains('active');

        // Collapse all panels
        panels.forEach((panel) => {
          if (panel.classList.contains('active')) {
            collapsePanel(panel);
          }
        });

        // If already open → just close it
        if (isActive) return;

        // Expand selected
        expandPanel(targetPanel);
      });
    });

    /* ==========================
     CLICK ON HEADING ONLY
    ========================== */

    section.addEventListener('click', function (e) {
      const heading = e.target.closest('.faq-heading');
      if (!heading) return;

      const item = heading.closest('.faq-item');
      if (!item) return;

      openItem(item, true);
    });

    /* ==========================
     KEYBOARD SUPPORT
    ========================== */

    section.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;

      const heading = e.target.closest('.faq-heading');
      if (!heading) return;

      e.preventDefault();

      const item = heading.closest('.faq-item');
      if (!item) return;

      openItem(item, true);
    });

    /* ==========================
     TOGGLE LOGIC
    ========================== */

    function openItem(item, updateUrl = false, shouldScroll = false) {
      const panel = item.closest('.faq-panel');
      if (!panel) return;

      const isOpen = item.classList.contains('active');

      // Close all items first
      panel.querySelectorAll('.faq-item').forEach((i) => {
        i.classList.remove('active');

        const answer = i.querySelector('.faq-answer');
        if (answer) answer.style.maxHeight = null;

        const btn = i.querySelector('.faq-question');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });

      // If already open → just close
      if (isOpen) {
        history.replaceState(null, null, window.location.pathname);
        return;
      }

      // Otherwise open it
      const answer = item.querySelector('.faq-answer');
      const button = item.querySelector('.faq-question');

      item.classList.add('active');

      if (answer) answer.style.maxHeight = answer.scrollHeight + 'px';
      if (button) button.setAttribute('aria-expanded', 'true');

      if (updateUrl) {
        history.replaceState(null, null, `#${item.id}`);
      }

      if (shouldScroll) {
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    /* ==========================
     DEEP LINK SUPPORT
     ========================== */

    function handleHash() {
      const hash = window.location.hash.replace('#', '');
      if (!hash) return false;

      const targetItem = section.querySelector(`#${hash}`);
      if (!targetItem) return false;

      const parentPanel = targetItem.closest('.faq-panel');
      if (!parentPanel) return false;

      const parentCategory = parentPanel.dataset.category;

      tabs.forEach((t) => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });

      panels.forEach((p) => p.classList.remove('active'));

      const correctTab = section.querySelector(`.faq-tab[data-category="${parentCategory}"]`);

      if (correctTab) {
        correctTab.classList.add('active');
        correctTab.setAttribute('aria-selected', 'true');
      }

      parentPanel.classList.add('active');

      setTimeout(() => {
        openItem(targetItem, false, true);
      }, 150);

      return true;
    }

    const hashHandled = handleHash();

    if (!hashHandled) {
      const firstPanel = section.querySelector('.faq-panel');
      const firstTab = section.querySelector('.faq-tab');

      // Reset everything
      panels.forEach((p) => {
        p.classList.remove('active');
      });

      tabs.forEach((t) => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });

      // DESKTOP → open first panel
      if (!isMobile) {
        if (firstPanel) firstPanel.classList.add('active');
        if (firstTab) {
          firstTab.classList.add('active');
          firstTab.setAttribute('aria-selected', 'true');
        }
      }

      // MOBILE → keep all collapsed
      if (isMobile) {
        panels.forEach((panel) => {
          const wrapper = panel.querySelector('.faq-items-wrapper');
          if (wrapper) {
            wrapper.style.height = '0px';
          }
        });
      }
    }

    window.addEventListener('hashchange', handleHash);

    function expandPanel(panel) {
      const wrapper = panel.querySelector('.faq-items-wrapper');
      if (!wrapper) return;

      panel.classList.add('active');

      const fullHeight = wrapper.scrollHeight;

      wrapper.style.height = '0px';

      requestAnimationFrame(() => {
        wrapper.style.height = fullHeight + 'px';
      });

      wrapper.addEventListener('transitionend', function handler() {
        wrapper.style.height = 'auto';
        wrapper.removeEventListener('transitionend', handler);
      });
    }

    function collapsePanel(panel) {
      const wrapper = panel.querySelector('.faq-items-wrapper');
      if (!wrapper) return;

      panel.querySelectorAll('.faq-item').forEach((item) => {
        item.classList.remove('active');

        const answer = item.querySelector('.faq-answer');
        if (answer) answer.style.maxHeight = null;

        const btn = item.querySelector('.faq-question');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });

      const fullHeight = wrapper.scrollHeight;

      wrapper.style.height = fullHeight + 'px';

      requestAnimationFrame(() => {
        wrapper.style.height = '0px';
      });

      wrapper.addEventListener('transitionend', function handler() {
        panel.classList.remove('active');
        wrapper.removeEventListener('transitionend', handler);
      });
    }
  }

  } catch(e) { console.error(e); }
})();
})();
